<template>
	<div class="private-order-tab-menu-mobile" :style="{ top: `${containerTop}px` }">
		<span
			v-if="isHasDescription"
			class="description-tab-item"
			:class="{ active: detailActiveSection === 'product-description' }"
			@click="handleScrollToSectionId('product-description')"
		>
			Deskripsi
		</span>

		<span
			v-if="isHasContent"
			class="description-tab-item"
			:class="{ active: detailActiveSection === 'product-content' }"
			@click="handleScrollToSectionId('product-content')"
		>
			Konten
		</span>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const baseContainerTop = 18;

export default {
	props: {
		yPos: {
			type: Number,
			default: 0,
		},
		isHasDescription: {
			type: Boolean,
			required: true,
		},
		isHasContent: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			isShowTabMenu: false,
			showMenuYPos: 0,
		};
	},
	computed: {
		...mapGetters({
			detailActiveSection: 'privateOrder/detailActiveSection',
			detailTargetSectionId: 'privateOrder/detailTargetSectionId',
		}),
		containerTop() {
			const maxTop = 43;
			if (this.isShowTabMenu) {
				const yPosition = this.yPos - this.showMenuYPos;
				return yPosition < maxTop
					? baseContainerTop + yPosition
					: maxTop + baseContainerTop;
			}
			return 0;
		},
	},
	watch: {
		detailTargetSectionId: {
			handler(newValue) {
				if (newValue === '') return;
				const section = document.getElementById(newValue);
				if (section) {
					const sectionRect = section.getBoundingClientRect();
					const absoluteTop = sectionRect.top + window.pageYOffset;

					window.scrollTo({
						top: absoluteTop - 118,
						behavior: 'smooth',
					});
				}
			},
		},
	},
	methods: {
		...mapActions({
			setDetailTargetSectionId: 'privateOrder/setDetailTargetSectionId',
		}),
		handleScroll() {
			const sectionId = 'product-description-tab';
			const section = document.getElementById(sectionId);
			if (section) {
				const rect = section.getBoundingClientRect();
				if (rect.bottom - 157 <= 0) {
					this.showMenuYPos = rect.bottom - 157 + window.scrollY;
					this.isShowTabMenu = this.isHasDescription || this.isHasContent;
				} else {
					this.showMenuYPos = 0;
					this.isShowTabMenu = false;
				}
			}
		},
		handleScrollToSectionId(sectionId) {
			this.setDetailTargetSectionId(sectionId);
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped lang="scss">
.private-order-tab-menu-mobile {
	width: 100%;
	height: 46px;
	background-color: #ffffff;
	position: fixed;
	z-index: 3;
	border-bottom: 1px solid #ebebeb;
	box-shadow: rgba(49, 53, 59, 0.12) 0px 1px 6px 0px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
}

span.description-tab-item {
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
	height: 100%;
	color: #80848e;
	cursor: pointer;
	transition: 0.1s all ease;
	border-bottom: 2.5px solid transparent;
	display: flex;
	align-items: center;

	&.active {
		color: #006dc7;
		border-bottom: 2.5px solid #006dc7;
	}
}
</style>
